<template>
	<div class="v-item" :inline="inline!==false||this.$parent.inline!==false" >
		<label class="v-item-label" :style="{width}">
			<v-text>{{label}}</v-text>
			<slot name="label"/>
		</label>
		<div class="v-item-content">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    label: {
      default: ""
    },
    labelWidth: {
      default() {
        let { _componentTag, propsData } = this.$parent.$options;
        return _componentTag == "v-form" ? propsData.labelWidth : "";
      }
    },
    inline: {
      default: false
    }
  },
  computed: {
    width() {
      return String(this.labelWidth).replace(/^(\d+)(px)?$/gm, "$1px");
    }
  }
};
</script>

<style lang="less">
.v-item {
  margin: 10px;
  display: flex;
  &[inline] {
    display: inline-flex;
  }
  > .v-item-label {
    color: #333333;
    line-height: 32px;
    margin-right: 10px;
    text-align: right;
  }
  > .v-item-content {
    flex: 1;
    line-height: 32px;
    position: relative;
    align-items: center;
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/vue-ext/components/form/item.vue